import React from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select'
import AudaxConstants from '../../../Constants';

class LocationFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "postcode",
      postcode: "",
      locationLat: null,
      locationLng: null,
      distance: 100
    }
 
    this.onChangeValue = this.onChangeValue.bind(this);
    this._onLocalityChange = this._onLocalityChange.bind(this);
    this._onPostcodeChange = this._onPostcodeChange.bind(this);
    this.sendUpdate = this.sendUpdate.bind(this);
    this._onDistanceChange = this._onDistanceChange.bind(this);
  } 
  componentDidUpdate(prevProps, prevState, snapshot){
    //if(this.props.selectedFilterType != prevProps.selectedFilterType){
	if(prevProps.selectedFilterType && this.props.selectedFilterType != prevProps.selectedFilterType){
      this.setState({postcode : ""});
    }
  } 
  sendUpdate() {
    this.props.onChange(this.state.type, this.state.postcode, this.state.locationLat, this.state.locationLng, this.state.distance || 0);
  }

  onChangeValue(event) {
    this.setState({ type: event.target.value }, this.sendUpdate);
  }
  _onLocalityChange(a, b, c) {
    var lat = a.value[0];
    var lng = a.value[1];
    this.setState({ locationLat: lat, locationLng: lng }, this.sendUpdate);
  }
  _onPostcodeChange(event) {
    this.setState({ postcode: event.target.value }, this.sendUpdate);
  }
  _onDistanceChange(event) {
    this.setState({ distance: event.target.value }, this.sendUpdate);
  }
  render() {

    var postClass;
    var locClass;
    var localityOptions = AudaxConstants.LocalityOptions.sort((a, b) => a.label > b.label ? 1 : -1)
    var isInvalidPostcode = false;
    if (this.state.type == "postcode") {
      postClass = "btn btn-sm btn-primary col-12";
      locClass= "btn btn-sm col-12";
    }
    else {
      postClass = "btn btn-sm col-12";
      locClass= "btn btn-sm btn-primary col-12";
    }

    if (this.props.query.LocationPostcodeGeocoded != null) {
      if (this.props.query.LocationPostcodeGeocoded == false) {
        isInvalidPostcode = true;
      }
    }

    return (
      <>

        {/* <div className="btn-group justified-content col-12" onChange={this.onChangeValue}> */}
        <div className="btn-group col-12 mb-2" onChange={this.onChangeValue}>
          {/* <label className="u-check"> */}
          <label className="col-6">
              <input className="d-none" name="location_filter" type="radio" value="postcode" defaultChecked={true} />
              {/* <span className="btn btn-sm btn-block u-btn-outline-lightgray g-color-white--checked g-bg-primary--checked rounded-0">Postcode</span> */}
              <span className={postClass}>Postcode</span>
            </label>
            <label className="col-6">
                <input className="d-none" name="location_filter" type="radio" value="locality" defaultChecked={false} />
                {/* <span className="btn btn-sm btn-block u-btn-outline-lightgray color-white--checked form-btn-primary-checked g-brd-left-none--md rounded-0">Locality</span> */}
                <span className={locClass}>Locality</span>
            </label>

         

        </div>
        
        {
          this.state.type == "postcode" && (
            <div className={"form-group col-12 mb-2 " + (isInvalidPostcode ? "u-has-error-v1" : "")}>
              <input className="form-control form-control-sm" type="text" placeholder="Postcode" value={this.state.postcode} onChange={this._onPostcodeChange} />
              {
                isInvalidPostcode && (<small className="form-control-feedback">Invalid postcode.</small>)
              }
            </div>
          )
        }
        {
          this.state.type == "locality" && (
            <Select
              onChange={this._onLocalityChange}
              options={localityOptions}
              className="basic-multi-select mb-2"
              classNamePrefix="select"
              styles={{
                menu: (baseStyles, state) => ({
                  ...baseStyles,
                  zIndex: 99,
                }),
              }} />
          )
        }

        <div className="input-group input-group-sm g-brd-primary--focus g-mb-10">
          <input className="form-control form-control-sm" type="number" placeholder="Distance" value={this.state.distance} onChange={this._onDistanceChange} />
          <div className="input-group-append">
            <span className="input-group-text input-group-text-sm">Km</span>
          </div>
        </div>

      </>

    );
  }
}
export default LocationFilter;

